import { render, staticRenderFns } from "./ArrematanteSubmenu.vue?vue&type=template&id=7dc16a71&"
import script from "./ArrematanteSubmenu.vue?vue&type=script&lang=js&"
export * from "./ArrematanteSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports